import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  createRecord,
  createServiceType,
  getCarByLicensePlate,
  getMonthlyLoad,
  getPlannedVisits,
  getRecordById,
  // getRecordsForDay,
  getServiceDataForBooking,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const crmSlice = createSlice({
  name: "crm",
  initialState: initialState.crm,
  reducers: {
    updateDates(state, action) {
      // console.log("action.payload CRM dates", action.payload);
      // state.dates = action.payload;
      if (action.payload?.startDate && action.payload?.endDate) {
        state.dates = action.payload;
      }
    },
    clearCarDataByPlate(state) {
      state.carDataByPlate = null;
    },
    clearRecordData(state) {
      state.record = null;
    },
  },
  extraReducers: builder =>
    builder
      // .addCase(getRecordsForDay.pending, handlePending)
      // .addCase(getRecordsForDay.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.dayRecords = action.payload.records;
      // })
      // .addCase(getRecordsForDay.rejected, handleRejected)

      // Create record +
      .addCase(createRecord.pending, handlePending)
      .addCase(createRecord.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(createRecord.rejected, handleRejected)

      // Get one record by ID +
      .addCase(getRecordById.pending, handlePending)
      .addCase(getRecordById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload;
      })
      .addCase(getRecordById.rejected, handleRejected)

      //Get booking data a particular date (for ServiceBookingModal) +
      .addCase(getServiceDataForBooking.pending, state => {
        state.isServiceDataLoading = true;
      })
      .addCase(getServiceDataForBooking.fulfilled, (state, action) => {
        state.isServiceDataLoading = false;
        state.serviceData.mechanics = action.payload.mechanics;
        state.serviceData.posts = action.payload.posts;
        state.serviceData.services = action.payload.services;
        state.serviceData.workingHours = action.payload.working_hours;
        state.serviceData.availability = action.payload.availability;
      })
      .addCase(getServiceDataForBooking.rejected, (state, action) => {
        state.isServiceDataLoading = false;
        state.error = action.payload;
      })

      .addCase(createServiceType.fulfilled, (state, action) => {
        state.isLoading = false;
        const categoryToAddIndex = state.serviceData.services.findIndex(
          service => service.id === action.payload.parent_id
        );

        if (categoryToAddIndex !== -1) {
          state.serviceData.services[categoryToAddIndex].children.push(
            {
              id: action.payload.id,
              name: action.payload.name_services,
              price: action.payload.price,
            }
            // action.payload.record
          );
        }
      })

      // Get planned visits for a planner table +
      .addCase(getPlannedVisits.pending, handlePending)
      .addCase(getPlannedVisits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.visits = action.payload.planner;
      })
      .addCase(getPlannedVisits.rejected, handleRejected)

      // Get monthly load for calendar +
      .addCase(getMonthlyLoad.pending, handlePending)
      .addCase(getMonthlyLoad.fulfilled, (state, action) => {
        state.isLoading = false;
        state.load = action.payload.load;
      })
      .addCase(getMonthlyLoad.rejected, handleRejected)

      .addCase(getCarByLicensePlate.pending, (state, action) => {
        state.isCarByPlateLoading = true;
        state.error = null;
      })
      .addCase(getCarByLicensePlate.fulfilled, (state, action) => {
        state.isCarByPlateLoading = false;
        state.carDataByPlate = action.payload[0];
      })
      .addCase(getCarByLicensePlate.rejected, (state, action) => {
        state.isCarByPlateLoading = false;
        state.error = action.payload;
      }),
});

export const { updateDates, clearCarDataByPlate, clearRecordData } =
  crmSlice.actions;

export default crmSlice.reducer;
